// extracted by css-extract-rspack-plugin
export default {"colorGray4":"#5e5e5e","legend":"legend__legend___sA8lW","keyColor":"legend__keyColor___A4OgF","keyText":"legend__keyText___Lzoh9 undefined"};